import { useQuery } from '@apollo/client';

import useConfig from 'app/config';
import LEADS_ACCESS from 'app/features/leads/graphql/leads-access.gql';
import type { LeadsAccessQuery, LeadsAccessQueryVariables } from 'app/types/graphql';
import { useAppState } from 'state';

export const useLeadsAccess = () => {
  const { config } = useConfig();
  const enabled = config.REACT_APP_GYM_FINDER_LEADS_ENABLED;
  const userId = useAppState(({ auth }) => auth.userId);
  const hasUser = userId != null;

  const { data, loading } = useQuery<LeadsAccessQuery, LeadsAccessQueryVariables>(LEADS_ACCESS, {
    variables: hasUser ? { id: userId } : undefined,
    skip: !enabled || !hasUser,
    fetchPolicy: 'cache-first',
  });

  const canManageGym = data?.userById?.permissions?.canManageGym ?? false;

  return {
    canAccessLeads: enabled && canManageGym,
    isLoading: enabled && hasUser && loading,
  };
};
